/** `data-user-guide-target` values for side navigation (see NavigationSetup + side-navigation-item). */
export const USER_GUIDE_SIDE_NAV_TARGET = {
  START_PAGE: 'side-nav-start-page',
  APP_FINDER: 'side-nav-app-finder',
  APP_MANAGER: 'side-nav-app-manager',
} as const;

export type UserGuideSideNavTargetId =
  (typeof USER_GUIDE_SIDE_NAV_TARGET)[keyof typeof USER_GUIDE_SIDE_NAV_TARGET];

/** Floating + button on the start page (`quick-menu-button`). */
export const USER_GUIDE_QUICK_MENU_BUTTON_TARGET = 'start-page-quick-menu' as const;

/** Folder / tab bar on the start page (`folder-bar`). */
export const USER_GUIDE_FOLDER_BAR_TARGET = 'start-page-folder-bar' as const;

/** "For You" tab button in the folder bar (`for-you-tab-button`). */
export const USER_GUIDE_FOR_YOU_TAB_TARGET = 'start-page-for-you-tab' as const;
